export interface ListRowLabelSummary {
  label: string;
  tooltip: string;
  dotColors: string[];
}

export function resolveListRowLabelSummary(value: unknown, fieldLabel: string): ListRowLabelSummary | null {

  const labels = (Array.isArray(value) ? value : [value])
    .filter((item): item is { name?: unknown; color?: unknown } => !!item && typeof item === 'object')
    .map(item => ({ name: String(item.name ?? '').trim(), color: typeof item.color === 'string' ? item.color : null }))
    .filter(item => !!item.name);

  if (!labels.length) return null;

  return {
    label: `${labels.length} ${labels.length === 1 ? 'label' : 'labels'}`,
    tooltip: `${fieldLabel}: ${labels.map(item => item.name).join(', ')}`,
    dotColors: labels.map(item => item.color).filter((color): color is string => !!color).slice(0, 3),
  };
}
